module.exports = __webpack_public_path__ + "img/7_85.06a207ea.png";